import { render } from "./question-panel.vue?vue&type=template&id=6f8a40f9&scoped=true&ts=true"
import script from "./question-panel.vue?vue&type=script&lang=ts"
export * from "./question-panel.vue?vue&type=script&lang=ts"

import "./question-panel.vue?vue&type=style&index=0&id=6f8a40f9&lang=scss&scoped=true"
import "./question-panel.vue?vue&type=style&index=1&id=6f8a40f9&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8a40f9"]])

export default __exports__